module.exports = __webpack_public_path__ + "img/项目场景_项目会议.fabccbc2.jpg";